
<div class="page-padding">
  <mat-card class="main-container mat-elevation-z2">

    <mat-card-content>
      <div class="content-padding">
        <div>
          <h2><span style="color: red; font-weight: bold;"><strong>Seneca</strong></span> | International</h2>
        </div>

        <div>

          <p>Agency ID: </p>
          <p>Company:</p>
          <p>Agent: ,</p>

        </div>
        
        <hr />

        <div>

          <p class="table-headers"> Commission Information</p>
 
          <table>

            <tr>
              <td>Status</td>
              <td></td>
            </tr>

            <tr>
              <td>Commission Amount</td>
              <td>$</td>
            </tr>

            <tr>
              <td>Tuition Amount</td>
              <td>$</td>
            </tr>

            <tr>
              <td>Term</td>
              <td></td>
            </tr>

            <tr>
              <td>Student Last Name, First Name</td>
              <td></td>
            </tr>

            <tr>
              <td>Application Number</td>
              <td></td>
            </tr>

            <tr>
              <td>Studentssss Number</td>
              <td></td>
            </tr>

            <tr>
              <td>Program Name (Code)</td>
              <td></td>
            </tr>

            <tr>
              <td>Campus</td>
              <td></td>
            </tr>

            <tr>
              <td>Student Country</td>
              <td></td>
            </tr>

            <tr>
              <td>Date Submitted</td>
              <td></td>
            </tr>

            <tr>
              <td>Agent Dispute Comments</td>
              <td></td>
            </tr>

            <tr>
              <td>Seneca Comments</td>
              <td></td>
            </tr>
          </table>

          <p class="table-headers">Payment Details</p>

          <table>
            <!--
              <tr>
              <td>Payment Method</td>
              <td></td>
            </tr>
            -->
           

            <tr>
              <td>Invoice</td>
              <td></td>
            </tr>
          </table>

          <p class="table-headers">Approver</p>

          <table>
            <tr>
              <td>Approver Name</td>
              <td></td>
            </tr>

            <tr>
              <td>Date Approved</td>
              <td></td>
            </tr>
          </table>
        </div>

        <br />

        <div>
          <button mat-flat-button type="button" class="seneca-button" color="primary" (click)="onCancel()">Back</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

